export default __webpack_public_path__ + "static/media/nick.e2725141.jpg";